import { RouteRecordRaw } from 'vue-router';

const roleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'role',
    component: () =>
      import('@/app/role/components/role-list-index-component.vue'),
    name: 'app.role',
  },
];

export default roleRoutes;
